import type { FormDefinition } from '@gov-design-system-ce/react-form-core';
import type { LocalizationLanguage } from '@gov-nx/core/app';
import type { Nullable } from '@gov-nx/core/types';
import type { DebouncedValue, IUseBoolean } from '@gov-nx/utils/common';
import type { SearchResultLink } from './utils';

export interface SearchAllTypesContext {
	setFilterTab: (type: SearchAllResultType) => void;
	setFilterAll: () => void;
	filter: SearchAllTypesListFilter;
	results: SearchAllTypesResult[];
	isFetching: boolean;
	formDefinition: FormDefinition<SearchAllTypesFilterForm>;
	numberOfResults: number;
	onSubmit: () => void;
	loadMoreResults: () => void;
	favorites: string[];
	isSortedAlphabetically: IUseBoolean;
	searchTerm: DebouncedValue<string>;
	searchValue: Nullable<string> | undefined;
	isSearchValue: boolean;
	recommendedResults: SearchAllTypesResult[];
	canLoadMoreRecommended: boolean;
	loadMoreRecommended: () => void;
	searchTerms: SearchAllSearchTerms[];
	isSearchOpened: IUseBoolean;
	removeSearchTerm: (searchTerm: string) => void;
	getSearchResultsPageUrl: (q?: string) => string;
	onSearch: () => void;
	currentSearchValue: Nullable<string> | undefined;
	recentVisited: SearchAllRecentVisited[];
	resolveAction: (item: SearchAllRecentVisited) => void;
}

export interface SearchAllTypesResult {
	title: string;
	description: string;
	action: () => void;
	link: SearchResultLink;
	type: SearchAllResultType;
	code: string | undefined;
	titleForSorting: string;
	order: number;
}

export interface SearchAllTypesListFilter {
	language: LocalizationLanguage;
	type: Nullable<SearchAllResultType>;
	favourites: boolean;
	pageSize: number;
}

export interface SearchAllTypesFilterForm {
	search?: Nullable<string>;
}

export enum SearchAllResultType {
	Signpost = 'signpost',
	UsefulLink = 'usefulLink',
	Faq = 'faq',
}

export interface SearchAllRecentVisited {
	rezaKod: string;
	title: string;
	type: SearchAllResultType;
	actionParams: SearchAllActionParams;
}

export interface SearchAllSearchTerms {
	rezaKod: string;
	searchTerm: string;
}

export interface SearchAllActionParams {
	pageCode?: string;
	serviceCode?: string;
	externalServiceId?: number;
	url?: string;
	faqSlug?: string;
}
